import { track } from '@vercel/analytics';

export const trackEvent = (eventName, properties = {}) => {
  try {
    track(eventName, properties);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.debug('Analytics event skipped:', eventName, error);
    }
  }
};
